import { Hero } from "@/components/home/hero"
import { Features } from "@/components/home/features"
import { Stats } from "@/components/home/stats"
import { Testimonials } from "@/components/home/testimonials"
import { CTA } from "@/components/home/cta"
import { useEffect } from "react"
import { trackRender } from "@/diagnostic"

export function HomePage() {
  // Track component render for diagnostics
  useEffect(() => {
    trackRender("HomePage");
    console.log("[HomePage] Component mounted");
    
    // Add a visible indicator that the HomePage has rendered
    const debugElement = document.createElement('div');
    debugElement.id = 'homepage-debug';
    debugElement.style.position = 'fixed';
    debugElement.style.bottom = '10px';
    debugElement.style.left = '10px';
    debugElement.style.padding = '5px 10px';
    debugElement.style.backgroundColor = 'rgba(0, 128, 0, 0.7)';
    debugElement.style.color = 'white';
    debugElement.style.fontSize = '12px';
    debugElement.style.borderRadius = '4px';
    debugElement.style.zIndex = '9999';
    debugElement.textContent = 'HomePage rendered';
    document.body.appendChild(debugElement);
    
    // Remove the debug element after 5 seconds
    setTimeout(() => {
      if (debugElement.parentNode) {
        debugElement.parentNode.removeChild(debugElement);
      }
    }, 5000);
    
    return () => {
      console.log("[HomePage] Component unmounted");
      // Clean up the debug element if it still exists
      const element = document.getElementById('homepage-debug');
      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, []);
  
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1">
        <Hero />
        <Features />
        <Stats />
        <Testimonials />
        <CTA />
      </main>
    </div>
  )
}